import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/homepage.js";
import AboutPage from "./pages/aboutpage.js";
import Gallery from "./pages/gallery.js";
import Pricing from "./pages/pricing.js";
import AlexPortfolio from "./pages/PP.js";
import SarahPortfolio from "./pages/SP.js";
// import other pages as you create them, e.g.:
// import Contact from "./pages/contact";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/pp-portfolio" element={<AlexPortfolio />} />
        <Route path="/sp-portfolio" element={<SarahPortfolio />} />
        {/* <Route path="/contact" element={<Contact />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
